"use client";

import React, { useState, useEffect } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFire,
  faBan,
  faClock,
  faLock,
  faEnvelopeOpen,
} from "@fortawesome/free-solid-svg-icons";
import globalVariables from "../../GlobalVariable";
import Turnstile, { useTurnstile } from "react-turnstile";

import "App.css";

import SubmissionModal from "../../components/SubmissionModal";

const FormAzucarai = ({
  idTrackGoogleAds,
  id2,
  chat,
  set_request_contact_is_send,
}) => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    service: "",
  });

  const [errors, setErrors] = useState({});
  const [captchaIsPassed, setCaptchaIspassed] = useState(false);
  const [vefifyCaptcha, setVerifyCaptcha] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // --- NUEVO ESTADO PARA EL MODAL ---
  const [modalState, setModalState] = useState(null); // null, 'submitting', 'success', 'error'
  const [businessData, setBusinessData] = useState(null);

  useEffect(() => {
    const fetchBusinessData = async () => {
      try {
        const response = await axios.get(`${globalVariables.domain}/business/azucarai`);
        if (response.data && response.data.content) {
          setBusinessData(response.data.content);
        }
      } catch (error) {
        console.error("Error fetching business data:", error);
      }
    };
    fetchBusinessData();
  }, []);

  const turnstile = useTurnstile();

  // --- FUNCIÓN PARA FORMATEAR TELÉFONO ---
  const formatPhoneNumber = (value) => {
    // Remover todo lo que no sea dígito
    const phoneNumber = value.replace(/\D/g, '');

    // Limitar a 10 dígitos
    const limitedNumber = phoneNumber.slice(0, 10);

    // Formatear como XXX-XXX-XXXX
    if (limitedNumber.length === 0) return '';
    if (limitedNumber.length <= 3) return limitedNumber;
    if (limitedNumber.length <= 6) {
      return `${limitedNumber.slice(0, 3)}-${limitedNumber.slice(3)}`;
    }
    return `${limitedNumber.slice(0, 3)}-${limitedNumber.slice(3, 6)}-${limitedNumber.slice(6)}`;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Formatear teléfono si es el campo phone
    if (name === "phone") {
      const formatted = formatPhoneNumber(value);
      setFormData((prev) => ({
        ...prev,
        [name]: formatted,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "This field is required";

    // Validar teléfono: debe tener exactamente 10 dígitos
    const phoneDigits = formData.phone.replace(/\D/g, '');
    if (!formData.phone.trim()) {
      newErrors.phone = "This field is required";
    } else if (phoneDigits.length !== 10) {
      newErrors.phone = "Phone number must be exactly 10 digits";
    }

    if (!formData.service.trim() || formData.service === "Select Service")
      newErrors.service = "This field is required";
    return newErrors;
  };

  // --- Funciones de notificación comentadas ---
  /*
  const sendEmail = async (email_message, subject) => { ... };
  const sendSms = async (to, body) => { ... };
  */

  function obtenerTimestampActual() {
    return Date.now();
  }

  const gtag_report_conversion = (url) => {
    const callback = () => {
      if (typeof url !== "undefined") {
        window.location = url;
      }
    };
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: `${idTrackGoogleAds}/${id2}`,
        event_callback: callback,
      });
    }
    return false;
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${idTrackGoogleAds}`;
    document.head.appendChild(script);

    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;
      gtag("js", new Date());
      gtag("config", `${idTrackGoogleAds}`);
    };

    return () => {
      document.head.removeChild(script);
    };
  }, [idTrackGoogleAds]);

  const saveLead = async () => {
    try {
      // Obtener solo los dígitos del teléfono (sin formato) para el backend
      const phoneDigits = formData.phone.replace(/\D/g, '');

      const data = {
        conversationId: "N/A",
        locationId: "manual",
        lastMessageDate: obtenerTimestampActual(),
        fullName: formData.name,
        tags: [formData, "azucarai web form"],
        phone: phoneDigits, // Enviar solo dígitos sin formato
        email: formData.email,
        lead_source: "form",
      };
      await axios.post(`${globalVariables.domain}/lead_systematik/`, data);
      gtag_report_conversion();
    } catch (error) {
      console.error("Error saving lead:", error);
      throw error;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    if (!captchaIsPassed) {
      setVerifyCaptcha(true);
      return;
    }

    setIsSubmitting(true);
    setModalState("submitting");
    setErrors({});

    try {
      await saveLead();
      setModalState("success");
    } catch (error) {
      console.error("Form submission error:", error);
      setModalState("error");
    }
    // El 'finally' ya no es necesario aquí para setIsSubmitting
  };

  // --- NUEVA FUNCIÓN PARA CERRAR EL MODAL Y REINICIAR ---
  const handleCloseModal = () => {
    setModalState(null);
    setIsSubmitting(false);
    // Reiniciar el formulario solo si el envío fue exitoso
    if (modalState === "success") {
      setFormData({ name: "", phone: "", service: "", email: "" });
      if (turnstile) turnstile.reset();
      setCaptchaIspassed(false);
      setVerifyCaptcha(false);
      if (set_request_contact_is_send) set_request_contact_is_send(true);
    }
  };

  const main_div_class = chat
    ? ""
    : "flex flex-col items-center justify-center bg-transparent";

  return (
    <>
      <SubmissionModal
        state={modalState}
        onClose={handleCloseModal}
        companyName={businessData?.business_name || "Azucará"}
        phoneNumber={businessData?.phone_web || businessData?.main_phone || businessData?.phone_google || businessData?.phone_yelp || "+1 (408) 509-0579"}
      />
      <div className={main_div_class}>
        <div className="w-full ">
          <form onSubmit={handleSubmit} className="space-y-4 p-4">
            {/* Inputs en grid si chat = true */}
            <div className={chat ? "grid grid-cols-2 gap-3" : "space-y-4"}>
              <div>
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={formData.name}
                  onChange={handleChange}
                  disabled={isSubmitting}
                  className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 ${errors.name
                    ? "border-red-500 focus:ring-red-500"
                    : "border-gray-300 focus:ring-blue-500"
                    }`}
                />
                {errors.name && (
                  <p className="mt-1 text-sm text-red-500">{errors.name}</p>
                )}
              </div>
              <div>
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={handleChange}
                  disabled={isSubmitting}
                  autoComplete="tel"
                  maxLength={12}
                  className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 ${errors.phone
                    ? "border-red-500 focus:ring-red-500"
                    : "border-gray-300 focus:ring-blue-500"
                    }`}
                />
                {errors.phone && (
                  <p className="mt-1 text-sm text-red-500">{errors.phone}</p>
                )}
              </div>
            </div>

            <div className={chat ? "grid grid-cols-2 gap-3" : "space-y-4"}>
              <div>
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                  disabled={isSubmitting}
                  className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 ${errors.email
                    ? "border-red-500 focus:ring-red-500"
                    : "border-gray-300 focus:ring-blue-500"
                    }`}
                />
                {errors.email && (
                  <p className="mt-1 text-sm text-red-500">{errors.email}</p>
                )}
              </div>
              <div>
                <select
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  disabled={isSubmitting}
                  className={`w-full px-4 py-2 border rounded-lg bg-white focus:outline-none focus:ring-2 ${errors.service
                    ? "border-red-500 focus:ring-red-500"
                    : "border-gray-300 focus:ring-blue-500"
                    }`}
                >
                  <option value="" disabled>
                    Select Service
                  </option>
                  <option value="SEO">SEO</option>
                  <option value="Social Media">Social Media</option>
                  <option value="Reviews">Reviews</option>
                  <option value="AI Marketing">AI Marketing</option>
                  <option value="Web Design">Web Design</option>
                  <option value="YelpAI Edge Software">
                    YelpAI Edge Software
                  </option>
                  <option value="Google Ads">Google Ads</option>
                  <option value="Custom AI Development">
                    Custom AI Development
                  </option>
                </select>
                {errors.service && (
                  <p className="mt-1 text-sm text-red-500">{errors.service}</p>
                )}
              </div>
            </div>

            {/* Captcha */}
            <div>
              <Turnstile
                sitekey="0x4AAAAAAA11EXR57l9M1Gd2"
                onVerify={() => setCaptchaIspassed(true)}
                theme="light"
              />
            </div>

            {!captchaIsPassed && vefifyCaptcha && (
              <p className="mt-1 text-sm text-red-500">
                This field is required
              </p>
            )}

            {/* Botón */}
            <div>
              <button
                type="submit"
                disabled={isSubmitting}
                className={`w-full px-4 py-2 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 transition-colors duration-300 ${isSubmitting
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#CA0712] hover:bg-red-700"
                  }`}
              >
                {isSubmitting ? "Submitting..." : "Request Service"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default FormAzucarai;
